import { Dispatch, RefObject, SetStateAction } from 'react';
import { isObject } from 'underscore';

import { assertIsCustomReactOption } from '@/utils/assertions/assert-is-custom-react-option';
import { ReactSelectInstanceRefObject, TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { IEventTag } from '@/types/projects.types';

type Params = {
  selectRef: ReactSelectInstanceRefObject;
  handleAdd: (tagName?: string) => void;
  setDisplayColorPicker: Dispatch<SetStateAction<IEventTag | null>>;
  workingTag: IEventTag;
  setWorkingTag: Dispatch<SetStateAction<IEventTag>>;
  draggableRef: RefObject<HTMLDivElement | null>;
};

const tagsSelectOnEnterKeyDown = ({
  selectRef,
  setDisplayColorPicker,
  handleAdd,
  setWorkingTag,
  workingTag,
  draggableRef,
}: Params) => {
  const _workingTag = { ...workingTag };

  const focusedOptionElement = selectRef?.current?.menuListRef?.querySelector('[data-tag-option-focused="true"]');
  const elementValue = focusedOptionElement?.getAttribute('value');
  let option: TReactSelectOption | null = null;
  // if selecting one of the dropdown options, we don't want to remove it, we want to open the color picker
  if (focusedOptionElement) {
    if (elementValue) {
      try {
        const _option = JSON.parse(elementValue);
        option = _option;
      } catch (error) {
        console.error('Cannot parse elementValue', error);
      }
    }
    if (!option) return;
    // if __isNew__, then use the value to overwrite the temp _workingTag name
    if (isObject(option) && option?.['__isNew__']) {
      assertIsCustomReactOption(option);
      if (!option.value?.toString().trim().length) return;
      _workingTag.name = option.value.toString();

      // if not new, then handle opening the color picker
    } else {
      try {
        const meta = (option.meta || null) as IEventTag | null;
        if (meta) {
          setDisplayColorPicker(meta);
          setWorkingTag(meta);
        }
        setTimeout(() => {
          // draggableRef > first button auto focus to enable tabbing in the popover
          const button = draggableRef.current?.querySelector('button');
          if (button) {
            button.focus();
          }
        }, 0);
      } catch (error) {
        console.error('Error parsing custom react option', error);
      }
      return;
    }
  }

  if (_workingTag?.name.trim().length) {
    // create new tag
    handleAdd(_workingTag?.name?.trim());

    // clear input value
    const select = selectRef?.current;
    if (select) {
      select?.onInputChange('', { action: 'set-value', prevInputValue: select?.props?.inputValue || '' });
    }
  }
};

export default tagsSelectOnEnterKeyDown;
